import script from "./VehicleDashboardMini.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDashboardMini.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDashboardMini.vue?vue&type=style&index=0&id=a49524f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a49524f2"]])

export default __exports__